import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTable, MatTableDataSource, MatTableModule} from "@angular/material/table";
import {Router} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {Subscription} from "rxjs";
import {MatSortModule} from "@angular/material/sort";
import {SortEvent} from 'allai-admin-shared';
import {PatientsControls} from "./patient-controls/patients-controls.component";
import {PatientRow} from "allai-admin-shared/dist/util/patient/patient-row";
import {PatientsService} from "../../services/patients/patients-service";
import {PatientsFilterService} from "../../services/patients/patient-filter.service";

/** The organization list page */
@Component({
	selector: 'app-organizations',
	imports: [
		MatTableModule,
		MatIconModule,
		MatButtonModule,
		PatientsControls,
		MatSortModule
	],
	templateUrl: './patients.component.html',
	styleUrl: './patients.component.scss'
})
export class PatientsComponent implements OnInit, OnDestroy {

	/** Columns in the table */
	readonly displayedColumns:(keyof PatientRow)[] = ['id', 'first_name', 'last_name', 'birthdate', 'email', 'phone', 'zip_code', 'id_organization', 'organization_name', 'sex', 'race', 'ethnicity'];

	/** Data source for the table */
	dataSource:MatTableDataSource<PatientRow>;

	/** Table on the page showing the patients */
	@ViewChild(MatTable)
	private table:MatTable<PatientRow>;

	/** Subscription for new organizations being loaded from filters */
	private newPatientsSub:Subscription;

	@ViewChild(PatientsControls)
	private patientControls:PatientsControls;

	constructor(private patientsService:PatientsService,
	            private patientFilterService:PatientsFilterService,
	            private router:Router) {
	}

	ngOnInit() {
		this.newPatientsSub = this.patientsService.onNewPatients.subscribe(() => {
			this.refresh();
		});

		this.patientsService.resolvePatients().then();
	}

	private refresh() {

		const patientList = this.patientsService.patientList;

		this.patientControls.setTotal(this.patientsService.total);

		//make sure to re-render the table
		this.dataSource = new MatTableDataSource<PatientRow>(patientList);
		this.table?.renderRows();
	}

	ngOnDestroy() {
		this.newPatientsSub?.unsubscribe();
	}

	/** Open an organization that was clicked on */
	goto(row:PatientRow) {
		let url = this.router.serializeUrl(this.router.createUrlTree(['/', 'patients', row.id]));
		window.open(url, `_user_${row.id}`);
	}

	sortData(sortEvent:SortEvent) {
		this.patientFilterService.sortOrder = sortEvent
	}
}
